<div class="modal-header">
    <h5 class="modal-title">Delete Post?</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>
<div class="modal-body">
    <p>
        This action can�t be undone. The post will be removed from your profile,
        the timeline of any accounts that follow you, and from search results.
    </p>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
    <button class="btn btn-danger" (click)="onConfirm()">Delete</button>
</div>
